// import locales from './language.json'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import langen from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'


let languagesSet = 'zh'
const cookies = document.cookie.split(';')
for (let cookie of cookies) {
  const [key, value] = cookie.trim().split('=')
  if (key === 'languagesSet') {
    languagesSet = decodeURIComponent(value)
    localStorage.setItem('languagesSet', languagesSet)
    const expires = new Date()
    expires.setDate(expires.getDate() + 7) // 7天后过期
    const hostname = window.location.hostname
    const domain = hostname.match(/([^.]+\.[^.]+)$/) || []
    console.log(domain[0], 'domain[0]') // 输出主域名，例如 example.com
    document.cookie = `languagesSet=${languagesSet}; domain=${domain[0]}; expires=${expires.toUTCString()}; path=/`
  }
}
const langs = {
  'en': langen
}
// let languagesSet = localStorage.getItem('languagesSet') || 'zh'
if (!languagesSet || languagesSet == 'zh') {
} else {
  locale.use(langs[languagesSet])
}
// 1. 先创建 i18n 实例（messages 初始为空）
const i18n = new VueI18n({
  locale: languagesSet, // 默认语言
  fallbackLocale: languagesSet,
  messages: {} // 初始为空
})

let path = window.origin
if (path.includes('http://local.ctrlbox.cn')) {
  path = 'http://pmsn.mate.glanway.org:8080'
}
// 2. 异步加载语言文件并动态注入
fetch(`${path}/language/language.json`)
  // fetch(`../../static/language.json`)
  .then(response => {
    if (!response.ok) throw new Error('Network error')
    return response.json()
  })
  .then(data => {
    // 将加载的 JSON 数据合并到 i18n 实例中
    Object.keys(data).forEach(lang => {
      i18n.mergeLocaleMessage(lang, data[lang]) // 合并语言包
    })
    console.log('i18n 语言包加载成功')
    if (data.setting) {
      localStorage.setItem('languagesSetting', JSON.stringify(data.setting))
      // localStorage.setItem('languagesSet', 'en')
    }
    // 可选：触发界面更新（例如在 Vue 根实例中配合 v-if 控制渲染时机）
  })
  .catch(error => {
    console.error('加载失败:', error)
    // 可选：加载失败时使用默认语言包或降级处理
  })

export default i18n


// WEBPACK FOOTER //
// ./src/utils/languages.js